<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <div
        class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4"
      >
        <h3 class="mb-0">Most Requested Item</h3>
      </div>

      <div style="margin-top: -25px; margin-left: -10px; margin-bottom: -25px">
        <apexchart
          v-if="isClient"
          type="bar"
          height="342"
          :options="projectsRoadmap"
          :series="roadmap"
        ></apexchart>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useDashboardStore } from "@/stores/dashboard/general";
import { defineComponent, ref, onMounted } from "vue";

export default defineComponent({
  name: "ProjectsRoadmapChart",
  setup() {
    const dashboardStore = useDashboardStore();
    const isClient = ref(false);

    const loadChartData = async () => {
      const { success } = await dashboardStore.dispatchMostItemRequested("");

      if (success) {
        const getData = dashboardStore.mostItemReq?.mostItemReq;

        const labels = getData?.label;
        const values = getData?.data;
        roadmap.value = [
          {
            name: "Total",
            data: values,
          },
        ];

        projectsRoadmap.value = {
          ...projectsRoadmap.value,
          xaxis: {
            ...projectsRoadmap.value.xaxis,
            categories: labels,
          },
        };
      }
    };

    const roadmap = ref([
      {
        name: "Total",
        data: [],
      },
    ]);
    const projectsRoadmap = ref({
      chart: {
        type: "bar",
        height: 342,
        toolbar: {
          show: false,
        },
      },
      colors: ["#3584FC"],
      plotOptions: {
        bar: {
          horizontal: true,
        },
      },
      grid: {
        show: true,
        borderColor: "#ECEEF2",
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [],
        axisTicks: {
          show: true,
          color: "#ECEEF2",
        },
        axisBorder: {
          show: true,
          color: "#ECEEF2",
        },
        labels: {
          show: true,
          style: {
            colors: "#8695AA",
            fontSize: "12px",
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: "#64748B",
            fontSize: "12px",
          },
        },
        axisBorder: {
          show: true,
          color: "#ECEEF2",
        },
        axisTicks: {
          show: true,
          color: "#ECEEF2",
        },
      },
    });

    onMounted(() => {
      isClient.value = true;
      loadChartData();
    });

    return {
      isClient,
      roadmap,
      projectsRoadmap,
    };
  },
});
</script>
